
let locale = {};
const messages = {};
const info = {};

let names = {
  en: "English",
  nl: "Nederlands",
  de: "Deutsch",
  es: "Español",
  pt: "Português",
  pl: "Polski",
  tr: "Türkçe",
  ja: "日本語",
};

if (process.env.NODE_ENV !== "testing") {
  /* eslint-disable no-undef */
  if (config.crowdinIntegration) {
    names["aa"] = "Crowdin";
  }
}

const codes = Object.keys(names);

let prefix = "";
switch (config.projectId) {
  case "WebApp":
    prefix = "web_app_";
    break;
  case "BusinessPortal":
    prefix = "billing_";
    break;
  case "DealerDashboard":
    prefix = "dd_";
    break;
  case "MyAccount":
    prefix = "web_app_";
    break;
  case "UserPortal":
    prefix = "web_app_";
    break;
  default:
    prefix = "web_app_";
}

for (let i = 0, len = codes.length; i < len; i++) {
  const abbr = codes[i];
  let x = require("@/assets/lang/" + prefix + abbr + ".json");
  messages[abbr] = x;
  info[abbr] = {
    code: abbr,
    name: names[abbr] || abbr,
  };
}

locale = {
  messages: messages,
  info: info,
  languages: names,
};

export default locale;
